// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#222834","menuText":"#C0C4CC"};